/*
 * @Description: 常规推广详情页面数据多店
 * @Author: kayvor
 * @Date: 2020-10-15 16:25:29
 * @LastEditors: kayvor
 * @LastEditTime: 2020-10-27 14:14:53
 */

import ajax from '../http/ajax'

export const getRegularInfo = (params) => {
    return ajax.get('getRegularInfo', params)
}
